<template lang="html">
  <div class="container">
    <Photo
      source="cdn"
      :img-id="xcxCode"
      width="150px"
      @photo-gotten="photoGotten"
      @preview="previewPhotos"
    />
    <p>长按上方小程序码收听节目</p>
    <span style="color:#999;font-size:0.9em">支持后台播放、锁屏播放、睡眠定时</span>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Image } from 'vant'
  import Photo from './photo.vue'
  Vue.use(Image)

  export default {
    components: {
      Photo
    },
    data () {
      return {
      }
    },
    props: {
      xcxCode: Number
    },
    computed: {
    },
    methods: {
      photoGotten () {},
      previewPhotos () {}
    },
    mounted () {
    }
  }
</script>

<style lang="css" scoped>
  .container {
    /* text-align: center; */
    display:flex;
    flex-direction:column;
    align-items:center;
    padding: 30px;
  }
</style>
